export function findPropertyByCode(state) {
  return (id) => state.properties.find(((v) => v.propertyCode === id));
}
